import { observer } from "mobx-react";
import React from "react";
import { DialogModalWithForm } from "../Components/DialogModal";
import { StyledPrimaryButton } from "../Components/StyledComponents/Buttons";
import { useStores } from "..";
import { PasswordInput } from "../Components/PasswordInput";

export const StudentLoginForm: React.FC<{}> = observer(() => {
  let mainWindowStore = useStores().mainWindowStore;

  return (
    <DialogModalWithForm className="auth-form" onCloseClick={mainWindowStore.onStudentLoginClose}>
      <DialogModalWithForm.Header>Авторизация</DialogModalWithForm.Header>
      <DialogModalWithForm.Body>
        <div>
          <label htmlFor="student-login-name">Имя</label>
          <input id="student-login-name" type="text" placeholder="Имя" required />
        </div>
        <div>
          <label htmlFor="student-login-password">Пароль</label>
          <PasswordInput id="student-login-password" type="password" placeholder="Пароль" required />
        </div>
        <div>
          <label htmlFor="student-login-group">Код группы</label>
          <input id="student-login-group" type="text" placeholder="Код группы" required />
        </div>
        <div>
          <StyledPrimaryButton
            onClick={function () {
              throw new Error("Function not implemented.");
            }}
          >
            Войти
          </StyledPrimaryButton>
        </div>
      </DialogModalWithForm.Body>
      <DialogModalWithForm.Footer>
        <a href="#">Регистрация</a>
        <a href="#password-reset" onClick={(event) => {
          event.preventDefault();
          mainWindowStore.onPasswordResetOpen();
        }}>Забыли пароль?</a>
      </DialogModalWithForm.Footer>
    </DialogModalWithForm>
  );
});
